<section class="section container">
  <app-searcher (setQueryParams)="setQueryParams($event)" (formValueChanged)="updateUrl($event)"></app-searcher>
</section>
